import { QueryFormColumn } from "@superset-ui/core";

export interface RGBAColor {
    r: number;
    g: number;
    b: number;
    a: number;
}

export interface DrillDownLevelData {
    filterValue: string;
    filterColumn: QueryFormColumn;
}

export enum AxisLabelSortOrder {
    None = 'none',
    Asc = 'asc',
    Desc = 'desc'
}

export enum DrillDownChartType {
    Bar,
    Pie
}
